import React, { useEffect } from "react";
import Header from "../Header/Header";
import "./FAQ.css";
import Footer from "../Footer/Footer";
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

export default function FAQ() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <Helmet>
      <title>Faq's About Hearing Aids in Singapore | The Hearing Centre</title>
        <meta name="description" content="Read our Frequently Asked Questions about hearing aids. To know more information about hearing aids visit the hearing centre website." />
        <meta property="og:title" content="Faq's About Hearing Aids in Singapore | The Hearing Centre"></meta>
        <meta property="og:description" content="Read our Frequently Asked Questions about hearing aids. To know more information about hearing aids visit the hearing centre website."></meta>
   
      </Helmet>
      <Header />
      <section className="hearing_service FAQ’s">
        <div className="container">
          <h1 className="Heading_text">FAQ’s</h1>
        </div>
      </section>

      <section className="FAQ_text">
        <div className="container">
          <div className="step1_text">
            <h1>Frequently Asked Questions</h1>
            <div className="accound">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      WHAT ARE THE TYPES AND CAUSES OF HEARING LOSS?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p>
                        The following are the different types of hearing loss:
                      </p>
                      <p>
                        <span>Conductive hearing loss:</span> hearing loss
                        caused by problems with the ear canal, eardrum or middle
                        ear. Some possible causes include:
                      </p>

                      <ul>
                        <li>
                          Malformation of outer ear, ear canal, or middle ear
                          structures
                        </li>
                        <li>Fluid in the middle ear</li>
                        <li>
                          Ear infection (otitis media – an infection of the
                          middle ear in which an accumulation of fluid may
                          interfere with the movement of the eardrum and
                          ossicles)
                        </li>
                        <li>Poor Eustachian tube function</li>
                        <li>Perforated eardrum</li>
                        <li>Impacted earwax</li>
                        <li>Infection in the ear canal</li>
                        <li>Foreign body in the ear</li>
                        <li>Otosclerosis</li>
                      </ul>

                      <p>
                        <span>Sensorineural hearing loss:</span> hearing loss
                        caused by problems of the inner ear or nerve-related
                        hearing loss. Some possible causes include:
                      </p>

                      <ul>
                        <li>Noise exposure</li>
                        <li>Head trauma</li>
                        <li>Virus or disease</li>
                        <li>Autoimmune inner ear disease</li>
                        <li>Hereditary</li>
                        <li>Aging (presbycusis)</li>
                        <li>Malformation of the inner ear</li>
                        <li>Meniere’s Disease</li>
                        <li>Tumors</li>
                      </ul>

                      <p>
                        <span>Mixed hearing loss:</span> hhearing loss referring
                        to a combination of conductive and sensorineural hearing
                        loss.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      WHICH HEARING AID IS THE BEST?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Each person has specific need when it comes to hearing
                      aids. It is based on the hearing test report and the
                      person’s lifestyle. It is important to talk with your
                      hearing care provider about what your needs are, what are
                      your expectations and what outcome you are looking for
                      before making the decision
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading3">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse3"
                      aria-expanded="false"
                      aria-controls="collapse3"
                    >
                      WHAT CAUSES HEARING LOSS IN CHILDREN?
                    </button>
                  </h2>
                  <div
                    id="collapse3"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading3"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Hearing loss at birth is called congenital hearing loss.
                      It can be caused by genetic factors, infection during
                      pregnancy, prematurity, injury at birth and others.
                      Hearing loss that occurs after birth is called acquired
                      hearing loss. It can be caused by ear infections, viral
                      and bacterial infections like meningitis or measles, head
                      injury and others.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading4">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse4"
                      aria-expanded="false"
                      aria-controls="collapse4"
                    >
                      WHAT IS A HEARING AID?
                    </button>
                  </h2>
                  <div
                    id="collapse4"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading4"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      A hearing aid is a small electronic device that you wear
                      in or behind your ear to help you hear better when you
                      have hearing loss.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading5">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse5"
                      aria-expanded="false"
                      aria-controls="collapse5"
                    >
                      HOW DO HEARING AIDS WORK?
                    </button>
                  </h2>
                  <div
                    id="collapse5"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading5"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      A hearing aid has three basic parts; a microphone,
                      amplifier and speaker. The hearing aid receives sound
                      through microphone then converts the sound to electrical
                      signal. The amplifier will then increase the power of the
                      signal and send it to the speaker.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading6">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse6"
                      aria-expanded="false"
                      aria-controls="collapse6"
                    >
                      WHAT IS THE MOST EXPENSIVE HEARING AID AVAILABLE?
                    </button>
                  </h2>
                  <div
                    id="collapse6"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading6"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Hearing aids cost around $900 to $7000 per piece. The main
                      defining factor of cost is the technology level. Meaning,
                      how intelligent the hearing aid is in processing speech
                      and environmental sounds in different listening
                      situations. The most expensive hearing aid would be the
                      one with a premium technology level, has a rechargeable
                      battery, and Bluetooth connectivity to smart phones,
                      laptop and TV. Also, the research and development costs of
                      hearing aids are high. This is because the chip inside the
                      hearing aids are not reused technology from any other
                      similar devices, they are custom made. As well as the
                      hardware development costs to program and fine tune the
                      hearing aids which are software-based. Such development is
                      important, as hearing aid manufacturers need to remain
                      competitive and offer better solutions to make the users
                      hear better and as normal as possible.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading7">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse7"
                      aria-expanded="false"
                      aria-controls="collapse6"
                    >
                      WHICH IS THE BEST BATTERY FOR HEARING AIDS?
                    </button>
                  </h2>
                  <div
                    id="collapse7"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading7"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Zinc air batteries with 1.45 volts are the best for
                      hearing aids. Make sure you use the correct size required
                      for your hearing aid type. There are four standard sizes
                      which are 675, 13, 312 and 10. The batteries use air as an
                      energy source, and the sticker on it seals the air holes.
                      Once the sticker is removed, it takes about two minutes
                      before the battery is activated.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading8">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse8"
                      aria-expanded="false"
                      aria-controls="collapse8"
                    >
                      WHAT IS THE BEST WAY TO MAINTAIN AND CLEAN YOUR HEARING
                      AIDS?
                    </button>
                  </h2>
                  <div
                    id="collapse8"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading8"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      The Hearing Centre gives you the electronic dehumidifier
                      which will sanitise the hearing aids as well as
                      dehumidifies it. It produces UV rays which will destroy
                      the bacteria and viruses
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading9">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse9"
                      aria-expanded="false"
                      aria-controls="collapse9"
                    >
                      CAN YOU WEAR HEARING AIDS WHEN YOU SLEEP?
                    </button>
                  </h2>
                  <div
                    id="collapse9"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading9"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      The Hearing Centre gives you the electronic dehumidifier
                      which will sanitise the hearing aids as well as
                      dehumidifies it. It produces UV rays which will destroy
                      the bacteria and viruses
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading10">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse10"
                      aria-expanded="false"
                      aria-controls="collapse10"
                    >
                      WHAT IS ONLINE HEARING TEST?
                    </button>
                  </h2>
                  <div
                    id="collapse10"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading10"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Online hearing test is a hearing screening option to get
                      the estimated level of your hearing. It is different from
                      the hearing test done in the clinic, where your
                      audiologist will physically examine your ears first before
                      the test and conduct a more diagnostic assessment of your
                      hearing. Online hearing test is usually used for hearing
                      awareness and only as a quick hearing check, this should
                      not be used to diagnose hearing loss and prescribe hearing
                      aids.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading11">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse11"
                      aria-expanded="false"
                      aria-controls="collapse11"
                    >
                      HOW DOES A HEARING AID WORK ON A TRACKER?
                    </button>
                  </h2>
                  <div
                    id="collapse11"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading11"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Starkey and GN ReSound hearing aids has a GPS tracker that
                      can locate your hearing aids with the use of the smart
                      phone app. This works for iPhone and ASHA compatible
                      Android phones.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading12">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse12"
                      aria-expanded="false"
                      aria-controls="collapse12"
                    >
                      WHAT ARE THE TIPS TO GET THE STARTED WITH OUR HEARING
                      AIDS?
                    </button>
                  </h2>
                  <div
                    id="collapse12"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading12"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <ul>
                        <li>
                          Wear your hearing aids Initially for few hours. Slowly
                          increase the duration and eventually wear them during
                          your waking hours. The more you wear your hearing
                          aids,the more sounds you will be able to detect and
                          filter so your brain will have been able to acclimate
                          faster.
                        </li>
                        <li>
                          They might feel funny initially but don’t be
                          discouraged
                        </li>
                        <li>
                          Start using in a quiet environment and slowly progress
                          to noisy environments
                        </li>
                        <li>
                          Read aloud . This will help used with your own voice
                        </li>
                        <li>
                          Always remember your hearing aids are not waterproof.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading121">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse121"
                      aria-expanded="false"
                      aria-controls="collapse121"
                    >
                      WHAT CAN CAUSE HEARING LOSS IN ONE EAR?
                    </button>
                  </h2>
                  <div
                    id="collapse121"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading121"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Some known causes include viral infections like mumps and
                      measles, head trauma, acoustic neuroma, labyrinthitis and
                      Meniere’s disease.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading13">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse13"
                      aria-expanded="false"
                      aria-controls="collapse13"
                    >
                      HOW MUCH DO HEARING AIDS COST?
                    </button>
                  </h2>
                  <div
                    id="collapse13"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading13"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Hearing aid pricing varies depending on the style, type
                      and most importantly, technology. The price of a single
                      hearing aid ranges from $800 to $6000+ per ear. This price
                      includes the cost of hearing examination, the
                      consultation, and fitting and post-fitting adjustments.
                      The device warranty can range from one to three years.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading14">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse14"
                      aria-expanded="false"
                      aria-controls="collapse14"
                    >
                      WHAT IS A BAHA HEARING AID?
                    </button>
                  </h2>
                  <div
                    id="collapse14"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading14"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Bone Anchored Hearing Aid (BAHA) is a surgically implanted
                      device for people with hearing loss. While conventional
                      hearing aids transmit sound through air conduction, BAHA
                      stimulates the cochlea through bone conduction., thereby
                      bypassing the outer and middle ear.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading15">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse15"
                      aria-expanded="false"
                      aria-controls="collapse15"
                    >
                      IS THERE ANY CURE FOR TINNITUS? WHAT SHOULD I DO?
                    </button>
                  </h2>
                  <div
                    id="collapse15"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading15"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      If your tinnitus is caused by an underlying health
                      condition that is treatable, addressing it may help to
                      stop or reduce the sound. One example of this is earwax
                      build-up. If you have hearing loss, hearing aids may help
                      to override or mask the tinnitus. Sound suppression may
                      also come from white noise machines that produce
                      stimulated environmental sounds such as ocean waves.
                      Cognitive Behavioral Therapy (CBT) aims to retrain the way
                      you think to change your behavior towards tinnitus and
                      eventually to reduce your anxiety. Alternative medicine
                      have little evidence of effectivity but some have tried to
                      resort to this method in managing tinnitus. This includes
                      acupuncture, hypnosis, ginkgo biloba, zinc supplements and
                      B vitamins.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading151">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse151"
                      aria-expanded="false"
                      aria-controls="collapse151"
                    >
                      WHAT ARE THE MOST DISCREET HEARING AIDS IN SINGAPORE?
                    </button>
                  </h2>
                  <div
                    id="collapse151"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading151"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Signia’s Silk X is the ideal hearing solution for those
                      who value discretion above all. It is a ready-to-wear CIC
                      under Signia’s Xperience platform. This means even with
                      its small size, the user is getting the advantage of clear
                      speech technology, wireless remote fine-tuning, and
                      ability to use Signia App that enables the user to adjust
                      their hearing aid settings with their smart phone.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading152">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse152"
                      aria-expanded="false"
                      aria-controls="collapse152"
                    >
                      WHICH IS THE BEST BRAND FOR BONE CONDUCTION?
                    </button>
                  </h2>
                  <div
                    id="collapse152"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading152"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Cochlear’s Bone Anchored Hearing Aid (BAHA) is the latest
                      and best in terms of technology. Their devices are
                      discreet and have a powerful range for those who have
                      conductive to mixed hearing losses. They have a
                      non-surgical option using Baha® SoundArc™ and Baha®
                      Softband, and if the user decides on having a BAHA system
                      that is surgically implanted, the same BAHA sound
                      processor can still be used without needing to buy a new
                      device. Cochlear’s BAHA is also the world’s first bone
                      conduction sound processor that can stream sound directly
                      from Apple devices (MFi technology).
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading16">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse16"
                      aria-expanded="false"
                      aria-controls="collapse16"
                    >
                      WHICH IS THE BEST HEARING AID FOR 2021?
                    </button>
                  </h2>
                  <div
                    id="collapse16"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading16"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      The Hearing Centre carries 4 of the major hearing aid
                      brands, which are Phonak, Starkey, GN Resound and Signia.
                      We want to give more options to our clients, especially
                      the first time users, because we believe that hearing is
                      very subjective, and that what fit your friend may not
                      always be the one suitable for you. Our experienced
                      audiologists will evaluate your hearing loss and lifestyle
                      needs to professionally advise you the models that will
                      match your needs. We also have a wide range of hearing
                      aids that can fit your cosmetic concerns and even budget
                      concerns.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading17">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse17"
                      aria-expanded="false"
                      aria-controls="collapse17"
                    >
                      WHAT ARE INVISIBLE HEARING AIDS?
                    </button>
                  </h2>
                  <div
                    id="collapse17"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading17"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Due to improvements in hearing aid technology, the hearing
                      aids available now come in different styles and sizes.
                      Users have varying definitions of “invisible”, whatever
                      you need, there is always a solution for you. There are
                      hearing aids that can match the colour of your skin and
                      your hair, there are hearing aids that look like a
                      Bluetooth earpiece (Hearables), and there is a discreet
                      type that is called invisible-in-the-canal (IIC) hearing
                      aid.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading18">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse18"
                      aria-expanded="false"
                      aria-controls="collapse18"
                    >
                      HOW MUCH DOES HEARING AID COST?
                    </button>
                  </h2>
                  <div
                    id="collapse18"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading18"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Hearing Aids price ranges from $900 to $7000 per piece.
                      Price depends on the hearing aid power, technology level,
                      rechargeability and Bluetooth connectivity. The Hearing
                      Centre offers a wide range of hearing aids depending on
                      the users budget.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading19">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse19"
                      aria-expanded="false"
                      aria-controls="collapse19"
                    >
                      DOES MILD HEARING LOSS REQUIRES HEARING AIDS?
                    </button>
                  </h2>
                  <div
                    id="collapse19"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading19"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      In deciding on whether hearing aids are suitable for you,
                      it is more important to focus on how hearing loss is
                      affecting you than just simply basing it on the level of
                      hearing loss. Mild hearing loss can be communication
                      barrier because it affects speech understanding in
                      presence of background noise (e.g. air conditioner,
                      background music and other people talking).
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading20">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse20"
                      aria-expanded="false"
                      aria-controls="collapse20"
                    >
                      WHICH IS THE MOST DIGITALLY ADVANCED HEARING AID AVAILABLE
                      IN SINGAPORE?
                    </button>
                  </h2>
                  <div
                    id="collapse20"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading20"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Phonak Hearing aids latest Paradise technology gives you
                      more crisp and natural sound quality. Its speech enhancer
                      will boost the soft level speech which results in
                      brilliant speech understanding. Using its Dynamic Noise
                      Cancellation you can personalize the amount of noise
                      cancellation you want all in real-time – all through the
                      MY Phonak app. It connects directly to IOS as well as
                      android phones. You can also simultaneously connect to two
                      Bluetooth devices..
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading21">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse21"
                      aria-expanded="false"
                      aria-controls="collapse21"
                    >
                      ARE HEARING AIDS BENEFICIAL?
                    </button>
                  </h2>
                  <div
                    id="collapse21"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading21"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Hearing aids are beneficial to hear better in the quiet as
                      well as noisy environments. If will slow down the
                      cognitive decline. It reduces the annoyance of tinnitus.
                      It will make you active and results in better quality of
                      social life
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="heading22">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse22"
                      aria-expanded="false"
                      aria-controls="collapse22"
                    >
                      WHO NEEDS HEARING AIDS?
                    </button>
                  </h2>
                  <div
                    id="collapse22"
                    className="accordion-collapse collapse"
                    aria-labelledby="heading22"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p>The following are the signs of hearing loss:</p>
                      Speech not so clear as before or feels muffled Difficulty
                      in understanding speech in noisy environments Often asks
                      people to repeat Trouble hearing people speaking from
                      behind or from another room Ringing or buzzing in your
                      ears Often needs to increase the Tv volume Difficulty in
                      following speech over Phone
                      <p>
                        If you have anyone or combination of symptoms, it is
                        necessary for your hearing to be checked. We provide
                        free hearing test in Singapore
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
